import Vue from 'vue';
import Axios from 'axios';
import AxiosRetry from 'axios-retry';

const axios = Axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
        },
    },
    withCredentials: true,
});

AxiosRetry(axios, { retries: 3 });

// Add $axios to Vue instance
Vue.prototype.$axios = axios;

export default axios;
